/**
 * Resource file for all public facing string constants in the app
 */
 const en_us = {
  LOCALE_KEY: 'ja_jp',

  LOCALE_NAME: '日本語（日本）',

  MISSING_TRANSLATION: '翻訳が見つかりません',

  MAPPING_ERROR_BANNER_WARNING: 'Product Mapping エラー! Please contact your local リゾート Tools administrator to resolve. Check Mapping Status ',

  MAPPING_ERROR_BANNER_HERE: 'こちら',

  PRODUCT_MAPPING_PAGE_INFO: 'Enter local point of sale product information for active entitlements to enable integration to resort /* TODO: translate */',

  VALIDATION_CONFIGURATION_PAGE_INFO: 'Adjust validity dates by entitlement. Usage outside of specified dates will not be valid /* TODO: translate */',

// SystemAdminPage.tsx
  SYSTEM_ADMIN_PAGE_TITLE: 'System Admin /* TODO: translate */',

  SAVE_CONFIG_ACTION_ERROR: 'There was an error saving the configuration. /* TODO: translate */',

  SAVE_CONFIG_SUCCESS_MSG: 'Configuration saved successfully /* TODO: translate */',

  GET_CONFIG_FETCH_ERROR: (resort: string) => `Unexpected error fetching the configuration settings for ${resort}. Using default configuration settings. /* TODO: translate */`,

  FEATURE_TOGGLES: 'Feature Toggles /* TODO: translate */',

  DIRECT_TO_WINDOW_LABEL: 'Direct to Window /* TODO: translate */',

  IS_UAT_LABEL:  'Is UAT /* TODO: translate */',

  IS_UAT_INFO: 'Whether or not the app is running in a ユーザー Acceptance Testing environment.',

  ALL_RESORTS_HOTLIST_LABEL: 'すべて Resorts Hotlist',

  ALL_RESORTS_HOTLIST_INFO: 'Allow hotlisting and unhotlisting guests from all resorts. /* TODO: translate */',

  RESORT_SPECIFIC_HOTLIST_LABEL: 'リゾート-Specific Hotlist',

  RESORT_SPECIFIC_HOTLIST_INFO: 'Allow hotlisting and unhotlisting guests from just this resort. /* TODO: translate */',

  ADD_TO_HOTLIST_LABEL: '追加 to Hotlist',

  ADD_TO_HOTLIST_INFO: 'Allow hotlisting guests. /* TODO: translate */',

  REMOVE_FROM_HOTLIST_LABEL: '削除 from Hotlist',

  REMOVE_FROM_HOTLIST_INFO: 'Allow unhotlisting guests who are currently hotlisted. /* TODO: translate */',

  REDEMPTION_WARNING_LABEL: 'Redemption 警告',

  REDEMPTION_WARNING_INFO: 'Show a warning to the user before allowing them to redeem an entitlement. Helpful for users who can\'t perform a corrective redemption. /* TODO: translate */',

  GROUP_PRINT_LABEL: 'Group Print /* TODO: translate */',

  GROUP_IMPORT_LABEL: 'Group Import /* TODO: translate */',

  SHOW_CAMERA_MIRRORING_LABEL: 'Show Camera Mirroring /* TODO: translate */',

  SHOW_CAMERA_MIRRORING_INFO: 'Allow users to flip web cam images horizontally to compensate for left-right reversal when pointing the web cam in certain directions. /* TODO: translate */',

  VALIDATION_CONFIGURATION_LABEL: 'Validation Configuration /* TODO: translate */',

  VALIDATION_CONFIGURATION_INFO: 'Allow users to view Validation Configuration for resort. /* TODO: translate */',

  MAPPING_ERROR_BANNER_LABEL: 'Mapping エラー Banner',

  MAPPING_ERROR_BANNER_INFO: 'Allow users to see product mapping error banner /* TODO: translate */',

  BULK_UPLOAD_LABEL: 'Product Mapping Bulk Upload /* TODO: translate */',

  BULK_UPLOAD_INFO: 'Allow users to use the product mapping bulk upload feature /* TODO: translate */',

  BULK_UPLOAD_NEXT: 'Next > /* TODO: translate */',

  BULK_UPLOAD_BACK: '< Back /* TODO: translate */',

  SEARCH_HISTORY_LABEL: '検索 History',

  SEARCH_HISTORY_INFO: 'Allow users to see search history /* TODO: translate */',

  ENABLE_CUSTOMER_IMPORT_LABEL: 'Enable Customer Import /* TODO: translate */',

  ENABLE_CUSTOMER_IMPORT_INFO: 'Which roles can use customer import /* TODO: translate */',

  ENABLE_DTW_LABEL: 'Enable DTW /* TODO: translate */',

  ENABLE_DTW_INFO: 'Enable Direct-to-Window Ticket Redemption for this site for these roles /* TODO: translate */',

  ENABLE_CORRECTIVE_REDEMPTION_LABEL: 'Enable Corrective Redemption /* TODO: translate */',

  ENABLE_CORRECTIVE_REDEMPTION_INFO: 'Which roles can redeem negative values on DTW and/or F&F and/or View Days tab entitlements /* TODO: translate */',

  MANAGE_USERS_LABEL: 'ユーザー管理',

  MANAGE_USERS_INFO: 'Who can manage user roles /* TODO: translate */',

  MANAGE_DAYS_LABEL: 'Manage Days /* TODO: translate */',

  MANAGE_DAYS_INFO: 'Who can manage day pass redemptions /* TODO: translate */',

  WEEKLY_VISITOR_REPORT_LIMIT_LABEL: '/* TODO */Weekly Visitor Report Limit',
  WEEKLY_VISITOR_REPORT_LIMIT_INFO: '/* TODO */ The number of reports that can be retrieved',
  
// PowCoin; Payment Methods and Registration
  POWCOIN_LABEL: 'Pay With Pass /* TODO: translate */',

  POWCOIN_INFO: 'Allow users to view and deregister guest payment registrations /* TODO: translate */',

  CHANGE_HISTORY_LABEL: 'Change History /* TODO: translate */',

  CHANGE_HISTORY_INFO: 'Allow users to view change history /* TODO: translate */',

  PAYMENT_REGISTRATION_GUEST_FIRST_NAME: '名 Name',

  PAYMENT_REGISTRATION_GUEST_NO_FIRST_NAME: 'いいえ 名 Name',

  DEACTIVATE_PAYMENT_REGISTRATION: '削除 payment registration',

  DEACTIVATE_PAYMENT_REGISTRATION_BUTTON: '削除',

  PAYMENT_REGISTRATION_WARNING: 'Payment registration and activation can only be completed through MyAccount on IkonPass.com by the guest. /* TODO: translate */',

  PAYMENT_REGISTRATION_NO_REGISTRATIONS: 'いいえ active payment registrations found for the current payment method.',

  PAYMENT_REGISTRATION_GUESTS: 'Authorized Guests /* TODO: translate */',

  PAYMENT_REGISTRATION_DEACTIVATE_ALL: 'Deactivate for すべて',

  PAYMENT_REGISTRATION_EXPIRY: (expiryMonth: string, expiryYear: string) => `Exp: ${expiryMonth} / ${expiryYear} /* TODO: translate */`,

  PAYMENT_REGISTRATION_VIEW: 'Manage payment registrations /* TODO: translate */',

  PAYMENT_REGISTRATION_ERROR_PAYMENT_METHOD_NOT_FOUND: 'Unexpected error trying to load the payment method.  Please refresh and try again. /* TODO: translate */',

  DEACTIVATE_PAYMENT_REGISTRATION_ERROR:  'deactivate Pay With Pass registration for one or more family members. Please review and retryに失敗しました。',

  DEACTIVATED_PAYMENT_REGISTRATION: (firstName: string) => `Registration deactivated for ${firstName} /* TODO: translate */`,

  GUEST_SNACKBAR_FAILED_PAYMENT_REGISTRATIONS: 'Unexpected error trying to load guest payment registrations. /* TODO: translate */',

  PAYMENT_REGISTRATION_DEACTIVATE_ALL_CONFIRMATION: 'Are you sure you want to remove all the payment registrations? /* TODO: translate */',

  PAYMENT_REGISTRATION_DEACTIVATE_CONFIRMATION: (guest: string) => `Are you sure you want to remove the payment registration for ${guest}? /* TODO: translate */`,

  PAYMENT_REGISTRATION_DEACTIVATE_CANCEL: 'キャンセル',

  PAYMENT_REGISTRATION_DEACTIVATE_SUCCEEDED: (guest: string) => `The payment registration for ${guest} has been successfully deactivated. /* TODO: translate */`,

// User Management

  USER_MANAGEMENT_PAGE_TITLE: 'ユーザー管理',

  USER_MANAGEMENT_PAGE_INFO: 'The following fields are required for user creation: 名, 姓, ユーザー名, ロール, リゾート, and パスワード',

  BLOCK_USER_ACTION_ERROR: 'block userに失敗しました。',

  GET_USERS_ACTION_ERROR: 'fetch usersに失敗しました。',

  UNBLOCK_USER_ACTION_ERROR: 'unblock userに失敗しました。',

  USER_FIELD_REQUIRED_VALIDATION: '必須',

  USER_FIELD_INVALID_CHARACTERS: (invalidChars: string) => `Must not include characters: ${invalidChars} /* TODO: translate */`,

  USER_NAME_NOT_AVAILABLE: 'ユーザー名 is not available',

  USER_NAME_FORMAT_VALIDATION: 'Must be 4 to 20 letters/numbers including underscore /* TODO: translate */',

  USER_EMAIL_FORMAT_VALIDATION: 'Must be a valid email address /* TODO: translate */',

  USER_EMAIL_NOT_AVAILABLE: 'Email is not available /* TODO: translate */',

  USER_PASSWORD_FORMAT_VALIDATION: 'Must have: • 8 or more characters • an uppercase letter • a lowercase letter • a number /* TODO: translate */',

  USER_MANAGEMENT_FAILED_USERNAMES_ERROR: (failedUsernames: string) => `失敗しました。 network request for: ${failedUsernames}, the username or email might already be in use.`,

  USER_MANAGEMENT_CREATE_USER_SUCCESS: (userName: string) => `${userName} created successfully. /* TODO: translate */`,

  USER_MANAGEMENT_FILTER_ERROR: (query: string) => `いいえ users match ${query}.  If a user does not show on your list it is possible the user exists in another resort.`,

  USER_MANAGEMENT_USERS_PER_PAGE: 'Users per page /* TODO: translate */',

  USER_MANAGEMENT_NO_USERS: 'いいえ Users',

  USER_MANAGEMENT_ACCOUNT_DISABLED: 'account disabled /* TODO: translate */',

  USER_MANAGEMENT_FETCH_USERS_FAILED: 'fetch users. Please refresh to try againに失敗しました。',

  USER_MANAGEMENT_REMOVE_USER_TITLE: '削除 ユーザー?',

  USER_MANAGEMENT_REMOVE_USER_MSG: (userToDelete: string) => `Are you sure you want to remove ${userToDelete}? /* TODO: translate */`,

  USER_MANAGEMENT_REMOVE_BUTTON: '削除',

  USER_MANAGEMENT_CANCEL_REMOVE_BUTTON: 'キャンセル',

  USER_MANAGEMENT_TABLE_FIRST_NAME: '名',

  USER_MANAGEMENT_TABLE_LAST_NAME: '姓',

  USER_MANAGEMENT_TABLE_USERNAME: 'ユーザー名',

  USER_MANAGEMENT_TABLE_EMAIL: 'Email /* TODO: translate */',

  USER_MANAGEMENT_TABLE_ROLE: 'ロール',

  USER_MANAGEMENT_TABLE_RESORTS: 'Resorts /* TODO: translate */',

  USER_MANAGEMENT_TABLE_PASSWORD: 'パスワード',

  USER_MANAGEMENT_TABLE_LAST_LOGIN: '姓 Login',

  USER_MANAGEMENT_TABLE_NO_USERS: 'いいえ users.',

  USER_ROW_ALL_RESORTS: 'すべて Resorts',

  USER_ROW_EXPAND_RESORTS: 'Expand Resorts /* TODO: translate */',

  USER_ROW_COLLAPSE_RESORTS: 'Collapse Resorts /* TODO: translate */',

  USER_ROW_SELECT_PLACEHOLDER: '選択...',

  USER_ROW_CREATE_USER: ' 作成 ユーザー',

  USER_ROW_SAVE_CHANGES: '保存 Changes',

  USER_ROW_DISCARD_CHANGES: 'Discard Changes /* TODO: translate */',

  USER_ROW_UPDATE_USER: 'Update ユーザー',

  USER_ROW_DELETE_USER: '削除 ユーザー',

  USER_ROW_FIRST_NAME: '名 Name',

  USER_ROW_LAST_NAME: '姓 Name',

  USER_ROW_USERNAME: 'ユーザー名',

  USER_ROW_SUGGESTED_USERNAME: (suggestedUsername: string) => `Suggested username  ${suggestedUsername} /* TODO: translate */`,

  USER_ROW_EMAIL: 'Email /* TODO: translate */',

  USER_ROW_USER_ROLE: 'ユーザー ロール',

  USER_ROW_NO_ROLES: 'いいえ Roles',

  USER_ROW_PASSWORD: 'パスワード',

  USER_ROW_UPDATE_PASSWORD: 'Update パスワード',

  USER_SEARCH_BOX_BLACKLIST_WARNING: '警告：Blacklisted 検索 Term',

  USER_SEARCH_BOX_TITLE: '検索 for a リゾート Tools ユーザー',

  USER_SEARCH_BOX_SEARCH: '検索',

  USER_SEARCH_BOX_PLACEHOLDER: 'Find a ユーザー',

  USER_EDIT_MENU_ENABLE_USER_TITLE: 'Enable user /* TODO: translate */',

  USER_EDIT_MENU_DISABLE_USER_TITLE: 'Disable user /* TODO: translate */',

  USER_EDIT_MENU_ENABLE_USER: 'Enable /* TODO: translate */',

  USER_EDIT_MENU_DISABLE_USER: 'Disable /* TODO: translate */',

  USER_EDIT_MENU_DELETE_USER_TITLE: '削除',

  USER_EDIT_MENU_RESET_PASSWORD: 'Reset PW /* TODO: translate */',

  USER_EDIT_MENU_MORE_OPTIONS: 'More Options /* TODO: translate */',

//User Preferences
  USER_PREFERENCE_MODAL_TITLE: 'Date & Language /* TODO: translate */',

  USER_PREFERENCE_MODAL_INFO: '選択 preferred date format and language',

  USER_PREFERENCE_MODAL_LANGUAGE: 'Language: /* TODO: translate */',

  USER_PREFERENCE_MODAL_DATE: 'Date Format: /* TODO: translate */',

  USER_PREFERENCE_MODAL_NO_LANGUAGES_ERROR: 'いいえ Languages, something went wrong',

  USER_PREFERENCE_MODAL_LANGUAGE_PLACEHOLDER: '選択 Language',

  USER_PREFERENCE_MODAL_NO_DATETIME_ERROR: 'いいえ Date codes, something went wrong',

  USER_PREFERENCE_MODAL_DATETIME_PLACEHOLDER: '選択 Date Format',

  USER_PREFERENCE_MODAL_APPLY: '適用 Changes',

  USER_PREFERENCE_MODAL_RESORT_DEFAULT: 'リゾート Default',

// Help and Training Pages
  HELP_TRAINING_PAGE_TITLE: 'Help and Training /* TODO: translate */',

  HELP_TRAINING_LOADING: 'Loading documents /* TODO: translate */',

  HELP_TRAINING_FETCH_FAILED: 'Failed to fetch training documents. Please refresh and try again. /* TODO: translate */',

  HELP_TRAINING_NO_DOCS: 'There are no training documents at this time. Please check back later for more info. /* TODO: translate */',

  HELP_TRAINING_VIEWER_FAILED: 'Failed to display this document. Please refresh and try again. /* TODO: translate */',

  HELP_TRAINING_BACK: 'Back to documents /* TODO: translate */',

  HELP_TRAINING_UPLOAD_BUTTON: 'Upload Document /* TODO: translate */',

  HELP_TRAINING_REPLACE_BUTTON: 'Replace /* TODO: translate */',

  HELP_TRAINING_DELETE_BUTTON: 'Delete /* TODO: translate */',

  HELP_TRAINING_FORM_TITLE_UPLOAD: 'Upload Training Document /* TODO: translate */',

  HELP_TRAINING_FORM_TITLE_REPLACE: 'Replace Training Document /* TODO: translate */',

  HELP_TRAINING_FORM_FILE_LABEL: 'Document file (.docx) /* TODO: translate */',

  HELP_TRAINING_FORM_DOC_TITLE_LABEL: 'Title /* TODO: translate */',

  HELP_TRAINING_FORM_SORT_ORDER_LABEL: 'Sort order /* TODO: translate */',

  HELP_TRAINING_FORM_SUBMIT: 'Save /* TODO: translate */',

  HELP_TRAINING_FORM_CANCEL: 'Cancel /* TODO: translate */',

  HELP_TRAINING_DELETE_CONFIRM_TITLE: 'Delete Document? /* TODO: translate */',

  HELP_TRAINING_DELETE_CONFIRM_MSG: (title: string) => `Are you sure you want to delete "${title}"? This cannot be undone. /* TODO: translate */`,

  HELP_TRAINING_WRITE_FAILED: 'That action failed. Please try again. /* TODO: translate */',

// FAQ Pages
  FAQ_PAGE_TITLE: 'Frequently Asked Questions /* TODO: translate */',

  FAQ_PAGE_FETCH_FAILED: 'fetch FAQs. Please refresh and try againに失敗しました。',

  FAQ_PAGE_NO_FAQ: 'There are no FAQs at this time. Please check back later for more info. /* TODO: translate */',

  FAQ_PAGE_LOADING_FAQ: '読み込み中 FAQs',

  MAKE_FAQ_PAGE_NO_FAQ: 'いいえ FAQs. Try creating a new one or uploading an existing JSON file above.',

  MAKE_FAQ_PAGE_MAKE_FAQ_JSON: 'Make FAQ JSON /* TODO: translate */',

  MAKE_FAQ_PAGE_NEW_FAQ: 'New FAQ /* TODO: translate */',

  MAKE_FAQ_PAGE_SAVE_FAQ: '保存',

// Release Notes Pages
  RELEASE_NOTES_PAGE_TITLE: 'Release Notes /* TODO: translate */',

  RELEASE_NOTES_PAGE_LOADING: '読み込み中 Release Notes',

  RELEASE_NOTES_PAGE_NO_NOTES: 'There are no Release Notes at this time. Please check back later for more info. /* TODO: translate */',

  RELEASE_NOTES_PAGE_FETCH_FAILED: 'fetch Release Notes. Please refresh and try againに失敗しました。',

  MAKE_RELEASE_NOTES_PAGE_JSON: 'Make Release Notes JSON /* TODO: translate */',

  MAKE_RELEASE_NOTES_NO_NOTES: 'いいえ Release Notes. Try creating a new one or uploading an existing JSON file above.',

  MAKE_RELEASE_NOTES_NEW_NOTE: 'New Note /* TODO: translate */',

  MAKE_RELEASE_NOTES_SUBMIT_NOTES: ' Submit Release Notes /* TODO: translate */',

// App Doc Form
  APP_DOC_FAQ_NEEDS_TITLE: 'This FAQ item needs a title! /* TODO: translate */',

  APP_DOC_FAQ_NEEDS_BODY: 'This FAQ item needs a body! /* TODO: translate */',

  APP_DOC_FAQ_ITEM_HEADER: 'FAQ Item /* TODO: translate */',

  APP_DOC_FORM_LABEL_TITLE: 'Title /* TODO: translate */',

  APP_DOC_FORM_LABEL_ROLES: 'Show for Roles /* TODO: translate */',

  APP_DOC_FORM_SUBLABEL_ROLES: '(Paste new value) /* TODO: translate */',

  APP_DOC_FORM_LABEL_DTW_RESORTS: 'For DTW Resorts /* TODO: translate */',

  APP_DOC_FORM_SAVE: '保存',

  APP_DOC_FORM_CANCEL: 'キャンセル',

// Auth
  GET_CONFIG_ACTION_ERROR : 'Unexpected error fetching the app\'s config settings. /* TODO: translate */',

  GET_USER_INFO_ACTION_ERROR: 'fetch userに失敗しました。',

  AUTH0_LOGIN_ERROR: 'Your account has been disabled.  Please contact your manager or an administrator. /* TODO: translate */',

  AUTH0_LOGIN: 'Login /* TODO: translate */',

  AUTH0_LOGIN_TITLE: 'Login to IKON リゾート',

  LOGIN_FORM_APP_CONFIG_FETCH_FAILED: 'fetch app configに失敗しました。',

  LOGIN_FORM_ALL_FIELDS_REQUIRED: 'すべて fields are required',

  LOGIN_FORM_ENTER_USERNAME: 'Enter your username /* TODO: translate */',

  LOGIN_FORM_USERNAME: 'ユーザー名',

  LOGIN_FORM_ENTER_PASSWORD: 'Enter your password /* TODO: translate */',

  LOGIN_FORM_PASSWORD: 'パスワード',

  LOGIN_FORM_LOGIN_TITLE: 'Login to IKON リゾート',

  LOGIN_FORM_LOGIN: 'Login /* TODO: translate */',

// Branding
  RESORT_TOOLS_LOGO_HEADER: 'リゾート Tools',

// copyToClipboard
  COPIED_TO_CLIPBOARD: 'Copied to clipboard! /* TODO: translate */',

  COPY_TO_CLIPBOARD: 'Copy to clipboard /* TODO: translate */',

// core
  GET_APPLIANCE_VERSION_ACTION_ERROR: 'Unexpected error fetching the appliance version. /* TODO: translate */',

// entitlementTypes
  GET_ENTITLEMENT_TYPES_ACTION_ERROR: 'load entitlement types. Please try again laterに失敗しました。',

// entitlementTypesMetadata
  GET_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR: 'fetch entitlement types metadataに失敗しました。',

  UPDATE_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR:  'Unexpected error updating entitlement types metadata. /* TODO: translate */',
  
  GET_ENTITLEMENT_TYPES_METADATA_HISTORY_ACTION_ERROR: 'fetch resort validation configuration change historyに失敗しました。',

  GET_FNF_BLACKOUTDATES_METADATA_ACTION_ERROR: 'fetch friends and family blackout dates metadataに失敗しました。',

// forms
  AUTO_FORM_SAVE: '保存',

  AUTO_FORM_RESET: 'Reset /* TODO: translate */',

  DROPDOWN_PLEASE_SELECT: 'Please select... /* TODO: translate */',

  CHARACTER_COUNT_CHARACTERS: 'Characters: /* TODO: translate */',

  PASSWORD_FIELD_SHOW_PASSWORD: 'Show パスワード',

  PASSWORD_FIELD_HIDE_PASSWORD: 'Hide パスワード',

  TOGGLE_SWITCH_ON: 'ON /* TODO: translate */',

  TOGGLE_SWITCH_OFF: 'OFF /* TODO: translate */',

// Landing page
  RESET_USER_PASSWORD_MISMATCH_ERROR: 'Passwords do not match, please re-enter your new password again /* TODO: translate */',

  RESET_USER_PASSWORD_RESET_COMPLETE: 'パスワード Reset Complete!',

  RESET_USER_PASSWORD_CANCEL: 'CANCEL /* TODO: translate */',

  RESET_USER_PASSWORD_OK: 'OK /* TODO: translate */',

  RESET_USER_PASSWORD_PASSWORD_RESET: 'パスワード Reset',

  RESET_USER_PASSWORD_RESET_INSTRUCTIONS: 'Please enter your new password twice /* TODO: translate */',

  RESET_USER_PASSWORD_PASSWORD_PLACEHOLDER: 'パスワード',

  RESET_USER_PASSWORD_CONNECTION_ERROR: 'Connection エラー. Please Try Again Later',

  RESET_USER_PASSWORD_SAVE: 'SAVE /* TODO: translate */',

// layout
  FLOATING_MENU_CLOSE: '閉じる menu',

  FLOATING_MENU_OPEN: 'Open menu /* TODO: translate */',

  MODAL_TITLE_HEADER_CLOSE: '閉じる',

// pageHeader
  HEADER_MENU_SYSTEM_ADMIN: 'System Administration /* TODO: translate */',

  HEADER_MENU_VALIDATION_CONFIG: 'Validation Configuration /* TODO: translate */',

  HEADER_MENU_USER_MANAGEMENT: 'ユーザー Management',

  HEADER_MENU_HELP_AND_TRAINING: 'Help and Training /* TODO: translate */',

  HEADER_MENU_FAQ: 'FAQ /* TODO: translate */',

  HEADER_MENU_REPORTS: 'Reports /* TODO: translate */',

  HEADER_MENU_RELEASE_NOTES: 'Release Notes /* TODO: translate */',

  HEADER_MENU_SIGNOUT: 'Signout /* TODO: translate */',

  HEADER_MENU_PRODUCT_MAPPING: 'Product Mapping /* TODO: translate */',

  PAGE_HEADER_BACK_TO_LANDING: 'Back to Landing Page /* TODO: translate */',

  PAGE_HEADER_SIGNED_IN_AS: (currentUser: string) => `Signed in as ${currentUser} /* TODO: translate */`,

  PAGE_HEADER_SIGNED_IN_AS_WITH_ROLE: (currentUser: string, userRole: string) => `Signed in as ${currentUser} ${userRole} /* TODO: translate */`,

  RESORT_SELECT_MENU_LOAD_CONFIG_ERROR: (resortName: string) => `Unexpected error fetching the configuration settings for ${resortName}. Using default configuration settings. /* TODO: translate */`,

// resortDetails
  GET_RESORT_DETAILS_ACTION_ERROR: 'いいえ resorts found in response',

// validationConfigurationTool
  VALIDATION_CONFIG_INVALID_EFFECTIVE_DATE: 'A valid start date is required. /* TODO: translate */',

  VALIDATION_CONFIG_INVALID_EXPIRATION_DATE: 'A valid expire date is required. /* TODO: translate */',

  VALIDATION_CONFIG_EXPIRES_BEFORE_EFFECTIVE_DATE: 'The product must expire on or after start date. /* TODO: translate */',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'The start date must be within one year of the season start date /* TODO: translate */',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'The start date must be less than the season end date /* TODO: translate */',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'The expire date must be within one year of the season end date /* TODO: translate */',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'The expire date must be greater than the season start date /* TODO: translate */',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_SEASON_START: '警告：The start date is outside the season start date',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_SEASON_END: '警告：The expire date is outside the season end date',

  VALIDATION_CONFIG_FAILED_NETWORK_REQUEST: '失敗しました。 network request while updating resort validation configuration.  Please try again later.',

  VALIDATION_CONFIG_UNABLE_TO_SAVE: 'Unable to save products!  Please check all dates for errors. /* TODO: translate */',

  VALIDATION_CONFIG_ERROR_OVERLAPPING_DATES: 'Product dates cannot overlap between Fulfillment Season /* TODO: translate */',

  VALIDATION_CONFIG_CANCEL_EDITS: 'キャンセル Edits',

  VALIDATION_CONFIG_EDIT_PRODUCTS: '編集 Products',

  VALIDATION_CONFIG_SAVE_PRODUCTS: '保存 Products',

  VALIDATION_CONFIG_SAVE: '保存',

  VALIDATION_CONFIG_CANCEL: 'キャンセル',

  VALIDATION_CONFIG_SHOW_HISTORY: 'Show History /* TODO: translate */',

  VALIDATION_CONFIG_HIDE_HISTORY: 'Hide History /* TODO: translate */',

  VALIDATION_CONFIG_SAVE_PRODUCTS_CONFIRMATION: 'Are you sure you want to save products? /* TODO: translate */',

  VALIDATION_CONFIG_DATA_CHANGE_WARNING : 'Any date range changes could affect live validations /* TODO: translate */',

  VALIDATION_CONFIG_START_DATE_PLACEHOLDER: 'Start Date /* TODO: translate */',

  VALIDATION_CONFIG_EXPIRE_DATE_PLACEHOLDER: 'Expire Date /* TODO: translate */',

  VALIDATION_CONFIG_NO_DATA: 'There are no validation configurations for this resort. /* TODO: translate */',

  VALIDATION_CONFIG_TABLE_PRODUCT: 'Product /* TODO: translate */',

  VALIDATION_CONFIG_TABLE_SEASON: 'Season /* TODO: translate */',

  VALIDATION_CONFIG_TABLE_FULFILLMENT_SEASON: 'Fulfillment Season /* TODO: translate */',

  VALIDATION_CONFIG_TABLE_MAX_DAYS: 'Max Days /* TODO: translate */',

  VALIDATION_CONFIG_TABLE_START_DATE: 'Start Date /* TODO: translate */',

  VALIDATION_CONFIG_TABLE_EXPIRE_DATE: 'Expire Date /* TODO: translate */',

  VALIDATION_CONFIG_TITLE: 'リゾート Validation Configuration',

  VALIDATION_CONFIG_ROW_UNLIMITED: '無制限',

  VALIDATION_CONFIG_ROW_MAX_DAYS: (maxDays: number) => `${maxDays} Days /* TODO: translate */`,

  VALIDATION_CONFIG_ROW_START_DATE: 'Start Date /* TODO: translate */',

  VALIDATION_CONFIG_ROW_EXPIRE_DATE: 'Expire Date /* TODO: translate */',

  METADATA_HISTORY_UPDATED: '更新済み',

  METADATA_HISTORY_USER: 'ユーザー',

  METADATA_HISTORY_VALUE: '新しい値',

  METADATA_HISTORY_UNKNOWN: '不明',

  METADATA_HISTORY_USER_NOT_FOUND: 'ユーザーが見つかりません',

  METADATA_HISTORY_USER_LOADING: 'ユーザーを読み込み中',

// version
  CENTRAL_APPLIANCE_VERSION: 'Central Appliance Version /* TODO: translate */',

  RESORT_TOOLS_VERSION: 'リゾート Tools Version',

// webcam
  PHOTO_BOOTH_CAM: 'Cam /* TODO: translate */',

  PHOTO_BOOTH_SELECT_WEBCAM: '選択 the WebCam to use to take pictures',

  PHOTO_BOOTH_SELECT_WEBCAM_PLACEHOLDER: '選択 a Cam',

  PHOTO_BOOTH_FLIP_CAMERA_FRAME_HORIZONTALLY: 'Flip the Camera Frame Horizontally /* TODO: translate */',

  PHOTO_BOOTH_FLIP_CAMERA_IMAGE_HORIZONTALLY: 'Flip the camera image horizontally. /* TODO: translate */',

  PHOTO_BOOTH_CANCEL_RETAKE: 'キャンセル Retake and Use Previous Photo',

  PHOTO_BOOTH_TAKE_NEW_PICTURE: 'Take a New Picture /* TODO: translate */',

  PHOTO_BOOTH_TAKE_PICTURE: 'Take Picture /* TODO: translate */',

  PHOTO_BOOTH_SAVE_PICTURE: '保存 This Picture',

  PHOTO_BOOTH_SAVE: '保存',

  PHOTO_BOOTH_RETAKE: 'Retake /* TODO: translate */',

  PHOTO_BOOTH_CAPTURE: 'Capture /* TODO: translate */',

  PHOTO_BOOTH_CANCEL: 'キャンセル',

  PHOTO_BOOTH_REVERSE_CAMERA: 'Reverse Camera /* TODO: translate */',

  WEBCAM_BROWSER_ERROR: 'This browser does not support native web cam capture. /* TODO: translate */',

  WEBCAM_STREAMING_ERROR: 'Camera is not streaming. /* TODO: translate */',

// resortMappingTool
  GET_RESORT_MAPPING_ACTION_ERROR: 'Unexpected error loading resort history. /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_MISSING_SALES_CHANNEL: 'Sales Channel Code may not be set for resort. /* TODO: translate */',

  GET_RESORT_MAPPING_HAS_ERROR_ACTION_ERROR: 'Unexpected error loading resort product mapping error status. /* TODO: translate */',

  GET_RESORT_MAPPINGS_NO_DATA: 'There are no resort product mappings found for this resort. /* TODO: translate */',

  UPDATE_MAPPING_ERRORS_ACTION_ERROR: 'Unexpected error loading product mapping. /* TODO: translate */',

  GET_PRODUCT_HYDRATION_ERRORS_ACTION_ERROR: 'Unexpected error loading product hydration errors. /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_TITLE: 'Bulk Upload Mappings /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_CLOSE: '閉じる',

  PRODUCT_MAPPING_UPLOAD_UPLOAD: 'Upload /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_REVIEW: 'Review /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_ADD_FILE: '追加 File',

  PRODUCT_MAPPING_UPLOAD_DOWNLOAD: 'Download Mappings /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_ONE: 'Download Mappings to get all available products /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_ONE_WARNING: 'Only active products can be mapped /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_TWO: 'Use downloaded file to add relevant details to resort specific columns /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_TWO_WARNING: 'Maintain all existing column headers, these are essential for upload success /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_THREE: 'Drag and drop or find your edited file to attach it to the uploader /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_FOUR: 'Click Next button to review edits /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_CHOOSE_FILE: 'Choose a CSV file to upload /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_INSTRUCTION: 'Drag .csv file こちら or click Choose File',

  PRODUCT_MAPPING_UPLOAD_SUCCESS: 'Uploaded CSV Successfully! /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_WRONG_HEADERS: 'The Column Headers for the editable columns are incorrect or not in the right order /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_NOT_ENOUGH_COLUMNS: 'At least one row has fewer columns than expected /* TODO: translate */',
  
  PRODUCT_MAPPING_UPLOAD_NO_MATCH: "No entitlement id matches found",

  PRODUCT_MAPPING_UPLOAD_NO_CHANGES: 'いいえ changes were detected',

  PRODUCT_MAPPING_UPLOAD_NO_FILE: 'いいえ file chosen',

  PRODUCT_MAPPING_UPLOAD_WRONG_FILE_TYPE: 'File is not a .csv file, please upload only .csv files /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_DUPLICATE_IDS: 'Duplicate Entitlement IDs detected /* TODO: translate */',

  PRODUCT_MAPPING_UPLOAD_FILE_INFO: 'File to upload: /* TODO: translate */',

  RESORT_MAPPING_COLUMN_PRODUCT: 'Product /* TODO: translate */',

  RESORT_MAPPING_COLUMN_SEASON: 'Season /* TODO: translate */',

  RESORT_MAPPING_COLUMN_AGE: 'Age /* TODO: translate */',

  RESORT_MAPPING_COLUMN_FULFILLMENT_SEASON: 'Fulfillment Season /* TODO: translate */',

  RESORT_MAPPING_COLUMN_PRODUCT_HEADER_CODE: 'Product Header Code /* TODO: translate */',

  RESORT_MAPPING_COLUMN_ACCESS_RULE: 'Access Rule /* TODO: translate */',

  RESORT_MAPPING_COLUMN_MEDIA_PRODUCT_HEADER_CODE: 'Media Product Header Code /* TODO: translate */',

  RESORT_MAPPING_COLUMN_DEPARTMENT: 'Department /* TODO: translate */',

  RESORT_MAPPING_COLUMN_CATEGORY: 'Category /* TODO: translate */',

  RESORT_MAPPING_COLUMN_ITEM: 'Item /* TODO: translate */',

  RESORT_MAPPING_COLUMN_PRODUCT_TYPE: 'Product Type /* TODO: translate */',

  RESORT_MAPPING_COLUMN_WTP_RELOAD: 'WtpReload /* TODO: translate */',

  RESORT_MAPPING_COLUMN_MAPPING_STATUS: 'Mapping Status /* TODO: translate */',

  RESORT_MAPPING_COLUMN_HYDRATION_ERRORS: 'Hydration Errors /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_LOAD_ERROR: 'Unexpected error loading resort mappings. /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_MAPPING_STATUS_LOAD_ERROR: 'Unexpected error loading or refreshing resort mapping statuses. /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_HYDRATION_ERROR_LOAD_ERROR: 'Unexpected error loading product hydration errors. /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_SYNC_SUCCESS: 'Product mappings synchronized successfully /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_SAVE_ERROR_MODAL: 'Unexpected error saving resort product mappings.  Please try again later. /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_SAVE_ERROR: 'Unexpected error saving resort product mappings /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_EDIT_PRODUCTS: '編集 Products',

  PRODUCT_MAPPING_PAGE_SAVE_PRODUCTS: '保存 Products',

  PRODUCT_MAPPING_PAGE_CANCEL_EDITS: 'キャンセル Edits',

  PRODUCT_MAPPING_PAGE_SYNC: 'Sync /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_DOWNLOAD: 'Download /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_BULK_UPLOAD: 'Bulk Upload /* TODO: translate */',

  PRODUCT_MAPPING_PAGE_TITLE: 'リゾート Product Mapping',

  PRODUCT_MAPPING_PAGE_NOT_IMPLEMENTED: 'Function not implemented. /* TODO: translate */',

  PRODUCT_MAPPING_HYDRATION_ERRORS_TOOLTIP: '失敗しました。 hydrations! Please resolve mapping status to retry.',

  PRODUCT_MAPPING_HYDRATION_ERRORS_INFO_TOOLTIP: 'Resolve existing mappings status errors to retry.  Retries will be queued and can take time to reprocess. /* TODO: translate */',

  PRODUCT_MAPPING_HYDRATION_ERRORS_RETRY: 'Retry /* TODO: translate */',

  PRODUCT_MAPPING_HYDRATION_ERRORS_RETRIED: 'Retried /* TODO: translate */',

  PRODUCT_MAPPING_HYDRATION_ERRORS_RETRY_SUCCESS: 'Messages have been sent to the queue for processing /* TODO: translate */',

  PRODUCT_MAPPING_HYDRATION_ERROR_RETRY_FAILURE: (productName: string, fulfillmentSeason?: string, ageBin?: string) =>
     `Unexpected error occurred retrying the ${productName} ${fulfillmentSeason} ${ageBin} product hydrations. Please try again later. /* TODO: translate */`,

//guest media

  ASSOC_RFID_REPRINT_MESSAGE_NO_ID: 'Guest does not have a media ID. Print a pass first. /* TODO: translate */',

  ASSOC_RFID_REPRINT_MESSAGE_HAS_ID: (currentRfid: string | undefined) => `Guest already has a linked pass. Reprint to disable the current pass and link a new pass.

Current RFID code: ${currentRfid} /* TODO: translate */`,

  ASSOC_RFID_MODAL_HEADER: 'Link RFID Card /* TODO: translate */',

  GUEST_LINK_RFID_LABEL: 'Link RFID /* TODO: translate */',

  GUEST_LINK_RFID_INPUT_TITLE: 'Enter RFID Number /* TODO: translate */',

  GUEST_LINK_RFID_INPUT_PLACEHOLDER: 'RFID Number /* TODO: translate */',

  RFID_LENGTH_ERROR: 'RFID ID must be a 20 digit number. Letters and symbols are not accepted. /* TODO: translate */',

  RFID_DUPLICATE_ERROR: (firstName: string, lastName: string, chipId: string) => `This RFID Code is already linked to ${firstName} ${lastName}.
RFID: ${chipId} /* TODO: translate */`,

  RFID_FORM_LABEL: 'Guest: /* TODO: translate */',

  RFID_FORM_TITLE: (guestName: string) => `Link RFID for ${guestName} /* TODO: translate */`,

  RFID_FORM_RETURN: 'Return to Guest Card /* TODO: translate */',

  RFID_FORM_CANCEL_RFID_LINKING: 'キャンセル RFID Linking',

  RFID_FORM_SUBMIT_RFID: 'Submit RFID /* TODO: translate */',

  RFID_FORM_OKAY: 'Okay /* TODO: translate */',

  RFID_FORM_CANCEL: 'キャンセル',

  RFID_FORM_SUBMIT: 'Submit /* TODO: translate */',

  MEDIA_HISTORY_MODAL_TITLE: 'Media Card History /* TODO: translate */',

  MEDIA_HISTORY_MODAL_ACTIVE: 'アクティブ',

  MEDIA_HISTORY_MODAL_INACTIVE: '非アクティブ',

  MEDIA_STATUS_SELECTOR_DISABLED: 'Disabled /* TODO: translate */',

  MEDIA_HISTORY_MODAL_COLUMN_ID: 'Media Card ID /* TODO: translate */',

  MEDIA_HISTORY_MODAL_COLUMN_RFID: 'RFID /* TODO: translate */',

  MEDIA_HISTORY_MODAL_COLUMN_AGENT: 'Agent /* TODO: translate */',

  MEDIA_HISTORY_MODAL_COLUMN_PRINT_DATE: 'Print Date /* TODO: translate */',

  MEDIA_HISTORY_MODAL_COLUMN_PRINT_STATUS: 'Print Status /* TODO: translate */',

  MEDIA_HISTORY_MODAL_COLUMN_RESORT: 'リゾート',

  MEDIA_HISTORY_MODAL_COLUMN_STATUS: 'Status /* TODO: translate */',

  MEDIA_HISTORY_MODAL_MESSAGE: 'Once a media card is disabled it cannot be re-enabled through リゾート Tools',

  MEDIA_HISTORY_MODAL_CONFIRMATION: (mediaId: string | undefined) => `Are you sure you want to disable media card ${mediaId}? /* TODO: translate */`,

  MEDIA_HISTORY_MODAL_DISABLE_MEDIA_SUCCESS_MESSAGE: (mediaId: string | undefined) => `Media Id ${mediaId} disabled successfully /* TODO: translate */`,

  MEDIA_HISTORY_MODAL_NO_DATA: 'いいえ media card history.',

  MEDIA_HISTORY_MODAL_FAILED_FETCH: (guestName: string) => `fetch ${guestName} media history. Please try againに失敗しました。`,

  MEDIA_HISTORY_MODAL_CANCEL: 'キャンセル',

  MEDIA_HISTORY_MODAL_CONFIRM: 'Confirm /* TODO: translate */',


  GROUP_PRINT_MODAL_LABEL: 'すべて Eligible',

  GROUP_PRINT_MODAL_GUEST_COUNT: (guestCount: number) => `Guests to Print: ${guestCount} /* TODO: translate */`,

  GROUP_PRINT_MODAL_WARNING: `Once you start this print request, the guests' existing passes will no longer work. /* TODO: translate */`,

  GROUP_PRINT_MODAL_CANCEL: 'キャンセル',

  GROUP_PRINT_MODAL_PRINT:  /* TODO: translate */'Print',

  GROUP_PRINT_MODAL_GENERATE_PDF:  /* TODO: translate */'Generating PDF',

  GROUP_PRINT_MODAL_LINK_RFID:  /* TODO: translate */'Link RFID:',

  GROUP_PRINT_MODAL_OKAY:  /* TODO: translate */'Okay /* TODO: translate */',

  GROUP_PRINT_MODAL_GROUP_LINK:  /* TODO: translate */'Group Link RFID',

  GROUP_PRINT_MODAL_GROUP_PRINT:  /* TODO: translate */'Group Print Pass',

  GROUP_PRINT_MODAL_FOUND_ERRORS: (errorCount) => `Found ${errorCount} errors /* TODO: translate */`,

  PASS_PRINT_MODAL_NO_ACTIVE_MEDIA: 'Unable to initiate reprint, guest does not have an Active piece of media.',

  PASS_PRINT_MODAL_GENERATE_PDF:  /* TODO: translate */'Generating PDF',

  PASS_PRINT_MODAL_CANCEL_TITLE:  /* TODO: translate */'Cancel Printing Pass for Guest',

  PASS_PRINT_MODAL_CANCEL:  /* TODO: translate */'キャンセル',

  PASS_PRINT_MODAL_HEADING:  /* TODO: translate */'Print Pass',

  PASS_PRINT_MODAL_OK_BTN_CLOSE:  /* TODO: translate */'閉じる',

  PASS_PRINT_MODAL_OK_BTN_PRINT:  /* TODO: translate */'Print',

  REISSUE_MEDIA_ACTION_UNKNOWN_ERROR:  /* TODO: translate */'Unknown error',

  NEED_PHOTO_AND_WAIVER:  /* TODO: translate */'To print a pass, ensure this guest signs a waiver and capture their photo.',
  NEED_PHOTO           :  /* TODO: translate */'To print a pass, capture this guest\'s photo. /* TODO: translate */',
  NEED_WAIVER          : 'To print a pass, ensure this guest signs a waiver. /* TODO: translate */',

  PRINT_CONFIRMATION_1: (guestName: string) => `Are you sure you want to print a new pass for ${guestName}? /* TODO: translate */`,
  PRINT_CONFIRMATION_2: 'The guest\'s existing pass will no longer work once you start the print process. /* TODO: translate */',

  API_ERROR: 'generate a PDF and initiate print. Please refresh and try againに失敗しました。',

  PRINT_FAILURE: 'Could not open PDF. Please check your popup blocker. /* TODO: translate */',

//guest redemption

  DTW_ENTITLEMENT_MODAL_MESSAGE: 'Once a day is redeemed it cannot be added back to the pass. /* TODO: translate */',

  DTW_ENTITLEMENT_MODAL_CONFIRMATION: 'Are you sure you want to redeem  /* TODO: translate */',

  DTW_ENTITLEMENT_MODAL_CONFIRMATION_NAME: (guestName: string) => `from ${guestName} /* TODO: translate */`,

  DTW_ENTITLEMENT_MODAL_CANCEL: 'キャンセル',

  DTW_ENTITLEMENT_MODAL_CONFIRM: 'Confirm /* TODO: translate */',

  DTW_ENTITLEMENT_MODAL_HEADING: 'Redeem Day Pass /* TODO: translate */',

  DTW_ENTITLEMENT_MODAL_GUEST_LABEL: "Guest:",

  DTW_ENTITLEMENT_MODAL_PASS_LABEL: "Pass:",

  DTW_ENTITLEMENT_MODAL_NO_ITEMS: "No Passes Available",

  DTW_ENTITLEMENT_MODAL_NO_DAYS: "No Days Available",

  DTW_ENTITLEMENT_MODAL_REDEMPTION_COMPLETE: ' Redemption Complete /* TODO: translate */',

  DTW_ENTITLEMENT_MODAL_FAILED_FETCH: (guestName: string) => `fetch ${guestName} entitlements. Please try againに失敗しました。`,

  DTW_ENTITLEMENT_MODAL_FAILED_REDEMPTION: (guestName: string) => `redeem ${guestName} Direct to Window days. Please try againに失敗しました。`,

  DTW_ENTITLEMENT_MODAL_PLURALIZED_DAY: (quantity: number) => `day${+quantity !== 1 ? 's /* TODO: translate */' :  /* TODO: translate */' /* TODO: translate */'} /* TODO: translate */`,

  FNF_TABLE_CONFIRMATION_REDEEM: 'Are you sure you want to redeem  /* TODO: translate */',

  FNF_TABLE_CONFIRMATION_RETURN: 'Are you sure you want to return  /* TODO: translate */',

  FNF_TABLE_CONFIRMATION_NAME: (days: string, possessiveGuestName: string) => ` Friends and Family ${days} from ${possessiveGuestName}  /* TODO: translate */`,

  FNF_TABLE_ENTITLEMENT_NAME: 'Entitlement Name /* TODO: translate */',

  FNF_TABLE_DAYS_AVAILABLE: 'Days Available /* TODO: translate */',

  FNF_TABLE_DAYS_USED: 'Days Used /* TODO: translate */',

  FNF_TABLE_REDEEM: 'Redeem /* TODO: translate */',

  FNF_TABLE_RETURN: 'Return /* TODO: translate */',

  FNF_TABLE_BLACKED_OUT: 'Blacked Out /* TODO: translate */',

  FNF_TABLE_ALL_USED: 'すべて Used',

  FNF_TABLE_NONE_USED: 'なし Used',

  FNF_TABLE_NO_ENTITLEMENTS: 'いいえ entitlements found.',

  FNF_TABLE_ACTION: 'Action /* TODO: translate */',

  FNF_TABLE_EXPAND_REDEMPTION_HISTORY: 'Expand Redemption History /* TODO: translate */',

  FNF_TABLE_COLLAPSE_REDEMPTION_HISTORY: 'Collapse Redemption History /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_COLUMN_REDEEM_DATE: 'Redeem Date /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_COLUMN_RESORT: 'リゾート',

  FNF_REDEMPTION_SUMMARY_COLUMN_REF_ID: 'Ref ID /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_COLUMN_TYPE: 'Type /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_NO_HISTORY: 'いいえ history',

  FNF_REDEMPTION_SUMMARY_ALL_RESORTS: 'すべて Resorts',

  FNF_REDEMPTION_SUMMARY_PENDING: 'Pending /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_REDEMPTION: 'Redemption /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_CLAIMED: 'Claimed /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_SHARED: 'Shared /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_SHARED_DATE: 'Shared date /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_REVOKED: 'Revoked /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_LABEL: 'Redemption Summary /* TODO: translate */',

  FNF_REDEMPTION_SUMMARY_FAILED_FETCH: (guestName: string) => `fetch ${guestName} share history. Please try againに失敗しました。`,

  FNF_REDEMPTION_SUMMARY_REDEMPTION_ID: (redemptionId: string) => `Redemption ID: ${redemptionId} /* TODO: translate */`,

  FNF_TABLE_PLURALIZED_DAY: (redeemQuantity: number) => `day${+redeemQuantity !== 1 ? 's /* TODO: translate */' :  /* TODO: translate */' /* TODO: translate */'} /* TODO: translate */`,

  FNF_MODAL_REDEMPTION_COMPLETE: 'Redemption Complete /* TODO: translate */',

  FNF_MODAL_RETURN_COMPLETE: 'Return Complete /* TODO: translate */',

  FNF_HISTORY_COLUMN_FROM_GUEST: 'From Guest /* TODO: translate */',

  FNF_HISTORY_COLUMN_TO_GUEST: 'To Guest /* TODO: translate */',

  FNF_HISTORY_COLUMN_SHARE_DATE: 'Share Date /* TODO: translate */',

  FNF_HISTORY_COLUMN_CLAIM_DATE: 'Claim Date /* TODO: translate */',

  FNF_HISTORY_COLUMN_REVOKE_DATE: 'Revoke Date /* TODO: translate */',

  FNF_HISTORY_COLUMN_STATUS: 'Status /* TODO: translate */',

  FNF_HISTORY_COLUMN_DATE: 'Date /* TODO: translate */',

  FNF_HISTORY_COLUMN_RESORT: 'リゾート',

  FNF_HISTORY_COLUMN_REF_ID: 'Ref ID /* TODO: translate */',

  FNF_HISTORY_SHARE: 'Share History /* TODO: translate */',

  FNF_HISTORY_REDEEM: 'Redemption History /* TODO: translate */',

  FNF_HISTORY_GUEST_LABEL: 'Guest: /* TODO: translate */',

  FNF_HISTORY_NO_HISTORY: 'いいえ history',

  FNF_HISTORY_COPY_MGID_TO_CLIPBOARD: 'Copy Master Guest ID to clipboard /* TODO: translate */',

  FNF_HISTORY_COPIED_MGID_TO_CLIPBOARD: 'Master Guest ID copied to clipboard /* TODO: translate */',

  FNF_HISTORY_FAILED_FETCH: (guestName: string) => `fetch ${guestName} share history. Please try againに失敗しました。`,

  FNF_MODAL_REDEEM_TAB: 'F&F Redeem /* TODO: translate */',

  FNF_MODAL_HISTORY_TAB: 'History /* TODO: translate */',

  FNF_MODAL_FAILED_FETCH: (guestName: string) => `fetch ${guestName} entitlements. Please try againに失敗しました。`,

  FNF_MODAL_FAILED_REDEMPTION: (guestName: string) => `redeem ${guestName} Friends and Family passes. Please try againに失敗しました。`,

  FNF_MODAL_ENTITLEMENT_LABEL: 'Entitlement Name: /* TODO: translate */',

  FNF_MODAL_NUMBER: 'Number /* TODO: translate */',

  FNF_MODAL_REDEEM_DATE: 'Redeem Date /* TODO: translate */',

  FNF_SELECT_DAYS_TO_RETURN: '選択 number of days to return',

  FNF_SELECT_DAYS_TO_REDEEM: '選択 date and number of friends and family days to redeem',

  FNF_TODAY_IS_BLACKOUT_DATE: 'Today is a black out date.  Please select a date in the future that is available /* TODO: translate */',

  FNF_SELECT_DATE_PLACEHOLDER: '選択 Date...',

  FNF_REDEEM_DATE_TOOLTIP: 'Enter the redemption date /* TODO: translate */',

  VIEW_DAYS_VIEW_DAYS_TAB_HEADER: 'View Days /* TODO: translate */',

  VIEW_DAYS_VIEW_HISTORICAL_TAB_HEADER: 'View Historical /* TODO: translate */',

  VIEW_DAYS_FAILED_FETCH_ERROR: 'fetch redemption typesに失敗しました。',

  VIEW_DAYS_HISTORY_ERROR: 'Unexpected error loading resort history. /* TODO: translate */',

  VIEW_DAYS_RESORT_SELECTOR_PASS_LABEL: 'Pass:  /* TODO: translate */',

  VIEW_DAYS_RESORT_SELECTOR_PASS_TITLE: 'Pass /* TODO: translate */',

  VIEW_DAYS_RESORT_SELECTOR_RESORT_LABEL: 'リゾート: ',

  VIEW_DAYS_RESORT_SELECTOR_RESORT_TITLE: 'Resorts /* TODO: translate */',

  VIEW_DAYS_TAB_NOT_APPLICABLE: 'N/A /* TODO: translate */',

  VIEW_DAYS_TAB_COLUMN_REDEMPTION_ID: 'Redemption ID /* TODO: translate */',

  VIEW_DAYS_TAB_COLUMN_TYPE: 'Type /* TODO: translate */',

  VIEW_DAYS_TAB_COLUMN_DATE: 'Date /* TODO: translate */',

  VIEW_DAYS_TAB_COLUMN_RESORT: 'リゾート',

  VIEW_DAYS_TAB_COLUMN_MODIFIED_BY: 'Modified By /* TODO: translate */',

  VIEW_DAYS_TAB_COLUMN_DAYS_USED: 'Days Used /* TODO: translate */',

  VIEW_DAYS_TAB_COLUMN_NOTES: 'Notes /* TODO: translate */',

  VIEW_DAYS_TAB_MODAL_HEADER: 'Correct Day Redemption /* TODO: translate */',

  VIEW_DAYS_CORRECTION_BUTTON_TITLE: 'Correct Redemption /* TODO: translate */',

  VIEW_DAYS_STATS_TOTAL_DAYS: 'Total Days /* TODO: translate */',

  VIEW_DAYS_STATS_RESORTS: 'Resorts /* TODO: translate */',

  VIEW_DAYS_STATS_MOST_VISITED: (name: string) => `Most: ${name} /* TODO: translate */`,

  VIEW_DAYS_GUEST_LABEL: 'Guest: /* TODO: translate */',

  VIEW_DAYS_FAILED_FETCH: (guestName: string) => `fetch ${guestName} resorts for this passに失敗しました。`,

  VIEW_DAYS_FAILED_HISTORY: (guestName: string) => `fetch ${guestName} history for a resort. Please try againに失敗しました。`,

  VIEW_DAYS_NO_DATA: 'There is no history for this guest at this resort. /* TODO: translate */',

  VIEW_DAYS_NO_DATA_FOUND_ERROR: 'いいえ Data Found',

  VIEW_DAYS_UNLIMITED: '無制限',

  VIEW_HISTORICAL_TAB_LOADING_DATA: '読み込み中 Historical Data',

  VIEW_HISTORICAL_TAB_TOTAL_DAYS: (totalDays: number) => `Total Days: ${totalDays} /* TODO: translate */`,

  DAY_CORRECTION_REDEMPTION_LABEL: 'Original Redemption ID: /* TODO: translate */',

  DAY_CORRECTION_REDEMPTION_TITLE: 'Original Redemption ID /* TODO: translate */',

  DAY_CORRECTION_REDEMPTION_BUTTON_TITLE: 'Copy Redemption ID to Clipboard /* TODO: translate */',

  DAY_CORRECTION_QUANTITY_LABEL: 'Correction Quantity: /* TODO: translate */',

  DAY_CORRECTION_INFO: 'Please provide a note for this negative day correction. /* TODO: translate */',

  DAY_CORRECTION_NOTE_LABEL: 'Correction Note: /* TODO: translate */',

  DAY_CORRECTION_INPUT: 'Correction Note /* TODO: translate */',

  DAY_CORRECTION_INPUT_PLACEHOLDER: 'Guest only took one run /* TODO: translate */',

  DAY_CORRECTION_BUTTON_TITLE: 'Correct Redemption & 閉じる',

  DAYS_REDEEM_NO_DAYS: `Guest doesn't have any more days to redeem /* TODO: translate */`,

  DAYS_REDEEM_SELECT_TITLE: 'Redeem Days',

  DAYS_REDEEM_REDEEM:  /* TODO: translate */'Redeem...',

  DAYS_REDEEM_BUTTON:  /* TODO: translate */'Redeem /* TODO: translate */',

  DAYS_REDEEM_NUMBER_DAYS: (i:number) => `${i} Day${i === 1 || i === -1 ?  /* TODO: translate */' /* TODO: translate */' :  /* TODO: translate */'s /* TODO: translate */'} /* TODO: translate */`,

  REDEMPTION_STATS_TOTAL_DAYS: 'Total Days /* TODO: translate */',

  REDEMPTION_STATS_DAYS_AVAILABLE:  /* TODO: translate */'Days Available /* TODO: translate */',

  REDEMPTION_STATS_DAYS_USED:  /* TODO: translate */'Days Used /* TODO: translate */',

  REDEMPTION_HISTORY_LABEL:  /* TODO: translate */'10 Most Recent Uses:',

  REDEMPTION_HISTORY_DATE:  /* TODO: translate */'Date /* TODO: translate */',

  REDEMPTION_HISTORY_RESORT:  /* TODO: translate */'リゾート',

  REDEMPTION_HISTORY_REF_ID:  /* TODO: translate */'Ref ID /* TODO: translate */',

  REDEMPTION_HISTORY_NO_HISTORY:  /* TODO: translate */'No History',

  REDEMPTION_ID_LABEL:  /* TODO: translate */'Redemption ID:',

  REDEMPTION_ID_TITLE:  /* TODO: translate */'Redemption ID /* TODO: translate */',

  REDEMPTION_ID_BUTTON_TITLE:  /* TODO: translate */'Copy Redemption ID to Clipboard /* TODO: translate */',

  REDEMPTION_ID_REFERENCE_LABEL:  /* TODO: translate */'Local Reference ID:',

  REDEMPTION_ID_REFERENCE_TITLE:  /* TODO: translate */'Local Reference',

  REDEMPTION_ID_SAVE_BUTTON_TITLE:  /* TODO: translate */'Save Local Reference & Close',

  REDEMPTION_ID_SAVE_BUTTON:  /* TODO: translate */'Save & Close',

//waivers
  WAIVER_ERROR:  /* TODO: translate */'error',

  WAIVER_UNKNOWN:  /* TODO: translate */'unknown',

  WAIVER_ALL_FIELDS_REQUIRED:  /* TODO: translate */'All fields are required.',

  WAIVER_ERROR_OVER_18:  /* TODO: translate */'Guest must be 18 years of age to sign a waiver.',

  WAIVER_UNKNOWN_ERROR:  /* TODO: translate */'Encountered an unknown waiver submission error',

  WAIVER_GENERIC_COMMENT:  /* TODO: translate */'Stub waiver reduced in from successful submit waiver action',

  WAIVER_MODAL_LOADING:  /* TODO: translate */'Loading...',

  WAIVER_MODAL_ERROR:  /* TODO: translate */'Error - contact support',

  WAIVER_MODAL_UNKNOWN_TYPE: (version: number) => `不明 Waiver Type: ${version}`,

  WAIVER_MODAL_HEADING: 'Waivers',

  WAIVER_SIGNATURE_COMPLETED_BY:  /* TODO: translate */'Waiver Completed By:',

  WAIVER_SIGNATURE_FIRST_NAME_LABEL:  /* TODO: translate */'名 Name',

  WAIVER_SIGNATURE_FIRST_NAME_TITLE: `The signer /* TODO: translate */'s first name /* TODO: translate */`,

  WAIVER_SIGNATURE_FIRST_NAME_INPUT: `Enter the signer's first name /* TODO: translate */`,

  WAIVER_SIGNATURE_LAST_NAME_LABEL: '姓 Name',

  WAIVER_SIGNATURE_LAST_NAME_TITLE: `The signer /* TODO: translate */'s last name /* TODO: translate */`,

  WAIVER_SIGNATURE_LAST_NAME_INPUT: `Enter the signer's last name /* TODO: translate */`,

  WAIVER_SIGNATURE_DOB_LABEL: 'Date of Birth',

  WAIVER_SIGNATURE_DOB_TITLE: `The signer /* TODO: translate */'s birth date /* TODO: translate */`,

  WAIVER_SIGNATURE_DOB_INPUT:  `Enter the signer's date of birth /* TODO: translate */`,

  WAIVER_SIGNATURE_CANCEL_TITLE: 'Cancel Waiver Completion',

  WAIVER_SIGNATURE_SUBMIT_TITLE:  /* TODO: translate */'Submit Completed Waiver',

  WAIVER_CANCEL:  /* TODO: translate */'キャンセル',

  WAIVER_SUBMIT:  /* TODO: translate */'Submit /* TODO: translate */',

  WAIVER_TABLE_COLUMN_WAIVER:  /* TODO: translate */'Waiver',

  WAIVER_TABLE_COLUMN_WAIVER_SIGNED:  /* TODO: translate */'Waiver Signed',

  WAIVER_TABLE_COLUMN_DATE_SIGNED:  /* TODO: translate */'Date Signed',

  WAIVER_TABLE_UNKNOWN:  /* TODO: translate */'不明',

  WAIVER_TABLE_UNSIGNED:  /* TODO: translate */'Unsigned',

  WAIVER_TABLE_EXPIRED: (expirationDate : string | undefined) => ` (Expired: ${expirationDate}) /* TODO: translate */`,

  WAIVER_TABLE_SIGNED: 'Signed',

  WAIVER_TABLE_NOT_SIGNED:  /* TODO: translate */'Not Signed',

  WAIVER_TABLE_NO_WAIVERS:  /* TODO: translate */'No waivers found.',

  WAIVER_TABLE_GUEST_LABEL:  /* TODO: translate */'Guest: /* TODO: translate */',

  WAIVER_TABLE_CLICK_TO_SIGN:  /* TODO: translate */'Click to Sign',

//guest card

  GUEST_CARD_DEFERRED_BANNER:  /* TODO: translate */'PASS DEFERRED',

  GUEST_CARD_HOTLIST_ALL_RESORTS:  /* TODO: translate */'Hotlist - All Resorts',

  GUEST_CARD_HOTLIST_RESORT: (resortName: string) => `Hotlist - ${resortName} /* TODO: translate */`,

  GUEST_CARD_HOTLIST: 'Hotlist /* TODO: translate */',

  GUEST_CARD_MEDIA_DISABLED:  /* TODO: translate */'MEDIA DISABLED',

  GUEST_CARD_COPIED_MASTER_GUEST_ID:  /* TODO: translate */'Master Guest ID copied to clipboard!',

  GUEST_CARD_COPIED_MEDIA_ID:  /* TODO: translate */'Media ID copied to clipboard!',

  GUEST_CARD_FAILED_TO_LOAD:  /* TODO: translate */'Failed to Load',

  GUEST_CARD_OVERFLOW_TOGGLE:  /* TODO: translate */'Toggle Overflow Menu',

  GUEST_CARD_OVERFLOW_COPY_MGID:  /* TODO: translate */'Copy Master Guest ID',

  GUEST_CARD_OVERFLOW_VIEW_DAYS:  /* TODO: translate */'View Days /* TODO: translate */',

  GUEST_CARD_OVERFLOW_GUEST_HAS_PASS: `Guest /* TODO: translate */'s day pass usage /* TODO: translate */`,

  GUEST_CARD_OVERFLOW_GUEST_NO_PASS: `Guest has no pass for this season /* TODO: translate */`,

  GUEST_CARD_OVERFLOW_MEDIA_HISTORY: 'Media Card History /* TODO: translate */',

  GUEST_CARD_OVERFLOW_MEDIA_HISTORY_TITLE: (guestName: string) => `Media History for ${guestName} /* TODO: translate */`,

  GUEST_CARD_OVERFLOW_PUT_HOTLIST: 'Put this guest on the hotlist /* TODO: translate */',

  GUEST_CARD_OVERFLOW_ALREADY_HOTLISTED: 'すべて guest passes are already hotlisted',

  GUEST_CARD_OVERFLOW_NO_PASS_HOTLIST: 'Guest has no pass to be hotlisted /* TODO: translate */',

  GUEST_CARD_OVERFLOW_HOTLIST: '追加 to Hotlist',

  GUEST_CARD_OVERFLOW_VIEW_COMMENTS: 'View Comments /* TODO: translate */',

  GUEST_CARD_OVERFLOW_TAKE_HOTLIST: 'Take this guest off the hotlist /* TODO: translate */',

  GUEST_CARD_OVERFLOW_REMOVE_HOTLIST: '削除 from hotlist',

  GUEST_CARD_OVERFLOW_COMMENT_HISTORY: (guestName: string) => `Comment History for ${guestName} /* TODO: translate */`,

  GUEST_CARD_OVERFLOW_ADD_COMMENT: '追加 Comment',

  GUEST_CARD_OVERFLOW_ADD_COMMENT_TITLE: (guestName: string) => `追加 a comment for ${guestName}`,

  GUEST_PROFILE_YEARS_OLD: (age: number) => `${age} years old /* TODO: translate */`,

  GUEST_PROFILE_NO_DOB: 'いいえ Birth Date',

  GUEST_PROFILE_TOOLTIP: 'Pass Photo /* TODO: translate */',

  GUEST_PROFILE_DISABLED_TOOLTIP: 'Guest is hotlisted. /* TODO: translate */',

  GUEST_PROFILE_COPY_MGID_TO_CLIPBOARD: 'Copy Master Guest ID to clipboard /* TODO: translate */',

  PASS_OVERVIEW_NO_MEDIA: 'いいえ Media ID',

  PASS_OVERVIEW_TITLE: 'IKON Media ID (same as barcode number when printed) /* TODO: translate */',

  PASS_OVERVIEW_COPY_BUTTON: 'Copy Media ID to Clipboard /* TODO: translate */',

  PASS_OVERVIEW_SEASON: 'Season /* TODO: translate */',

  PASS_OVERVIEW_NAME: 'Name /* TODO: translate */',

  PASS_OVERVIEW_NO_PASSES: 'いいえ アクティブ Passes',

  PASS_OVERVIEW_NO_ENTITLEMENTS: 'いいえ Pass Entitlements',

  PRIMARY_ACTIONS_PRINT_CARD: 'Print Card /* TODO: translate */',

  PRIMARY_ACTIONS_LINK_CARD: 'Link RFID Card /* TODO: translate */',

  PRIMARY_ACTIONS_WAIVER_SIGNED: 'Guest Waiver is Signed /* TODO: translate */',

  PRIMARY_ACTIONS_WAIVER_SIGNATURE: 'Click to record a waiver signature /* TODO: translate */',

  SECONDARY_ACTIONS_REDEEM_PASS: 'View & Redeem Day Pass /* TODO: translate */',

  SECONDARY_ACTIONS_REDEEM_FNF: 'View & Redeem Friends and Family Day Pass /* TODO: translate */',

  SECONDARY_ACTIONS_IMPORT_TOOLTIP: 'Import Guest Record /* TODO: translate */',

//guest comments

  ADD_COMMENT_GUEST_LABEL: 'Guest: /* TODO: translate */',

  ADD_COMMENT_SUBJECT_LABEL: 'Subject /* TODO: translate */',

  ADD_COMMENT_COMMENTS_LABEL: 'Comments /* TODO: translate */',

  ADD_COMMENT_CHARACTER_INFO: (minChars: number, maxChars: number) => `(${minChars} to ${maxChars} characters) /* TODO: translate */`,

  ADD_COMMENT_ADD_COMMENT: '追加 Comment',

  ADD_COMMENT_BUTTON_TITLE: (guestName: string) => `追加 Comment to ${guestName}`,

  ADD_COMMENT_ERROR: 'Unexpected error adding a new guest comment. /* TODO: translate */',

  COMMENT_HISTORY_COLUMN_DATE: 'Date /* TODO: translate */',

  COMMENT_HISTORY_COLUMN_AGENT: 'Agent /* TODO: translate */',

  COMMENT_HISTORY_COLUMN_SUBJECT: 'Subject /* TODO: translate */',

  COMMENT_HISTORY_COLUMN_COMMENT: 'Comment /* TODO: translate */',

  COMMENT_HISTORY_NO_HISTORY: 'This guest has no comment history. /* TODO: translate */',

  COMMENT_HISTORY_FAILED_FETCH: (guestName: string) => `fetch ${guestName} comment history. Please try againに失敗しました。`,

  COMMENT_NO_SUBJECT: 'A subject is required. /* TODO: translate */',

  COMMENT_NO_COMMENT: 'A comment of 10 to 500 characters is required. /* TODO: translate */',

  COMMENT_HISTORY_FETCH_ERROR: `Unexpected error fetching guest's comment history. /* TODO: translate */`,

  COMMENT_HISTORY_VIEW_COMMENTS: 'View Comments /* TODO: translate */',

//guest contact

  ADDRESS_NO_ADDRESS_TITLE: `This guest doesn /* TODO: translate */'t have an address /* TODO: translate */`,

  ADDRESS_NO_ADDRESS: 'いいえ Address',

  ADDRESS_NO_DATA: 'いいえ Data',

  ADDRESS_LINE_ONE: 'Address Line 1 /* TODO: translate */',

  ADDRESS_LINE_TWO: 'Address Line 2 /* TODO: translate */',

  ADDRESS_CITY: 'City /* TODO: translate */',

  ADDRESS_NO_CITY: 'いいえ City, ',

  ADDRESS_STATE: 'State /* TODO: translate */',

  ADDRESS_NO_STATE: 'いいえ State',

  ADDRESS_POSTAL: 'Postal Code /* TODO: translate */',

  ADDRESS_NO_POSTAL: 'いいえ Postal Code, ',

  ADDRESS_COUNTRY: 'Country /* TODO: translate */',

  ADDRESS_NO_COUNTRY: 'いいえ Country',

//guest photo

  GUEST_PHOTO_MODAL_HEADING: 'Capture Photo /* TODO: translate */',

  GUEST_PHOTO_GUEST_LABEL: 'Guest: /* TODO: translate */',

//hotlist

  HOTLIST_ADD_HOTLIST: '追加 to Hotlist',

  HOTLIST_PUT_HOTLIST: (guestName: string) => `Put ${guestName} on hotlist /* TODO: translate */`,

  HOTLIST_NO_ENTITLEMENT: 'A pass must be selected to add to hotlist. /* TODO: translate */',

  HOTLIST_NO_RESORT: 'A resort must be selected. /* TODO: translate */',

  HOTLIST_NO_REASON: 'A reason is required to add to hotlist. /* TODO: translate */',

  HOTLIST_NO_COMMENT: 'A comment of 10 to 500 characters is required. /* TODO: translate */',

  HOTLIST_INVALID_EFF_DATE: 'A valid start date is required to add to hotlist. /* TODO: translate */',

  HOTLIST_INVALID_EXP_DATE: 'A valid end date is required to add to hotlist. /* TODO: translate */',

  HOTLIST_PREDATED_EFF_DATE: 'Hotlisting must take effect either today or in the future /* TODO: translate */',

  HOTLIST_EXPIRES_EFF_DATE: 'Hotlisting must expire on or after start date. /* TODO: translate */',

  HOTLIST_MODAL_NO_PASS_SELECTED: 'いいえ pass selected',

  HOTLIST_MODAL_GUEST_LABEL: 'Guest: /* TODO: translate */',

  HOTLIST_MODAL_PASS_LABEL: 'Pass /* TODO: translate */',

  HOTLIST_MODAL_PASS_PLACEHOLDER: 'Pass... /* TODO: translate */',

  HOTLIST_MODAL_FAILED_ENTITLEMENTS: 'load entitlementsに失敗しました。',

  HOTLIST_MODAL_RESORT_LABEL: 'リゾート',

  HOTLIST_MODAL_REPORTER_CONTACT_NUMBER: 'Reporter Contact Number /* TODO: translate */',

  HOTLIST_COMMENT_WITH_REPORTER_CONTACT: (phoneNumber: string, comment: string) => `Reporter Contact Number: ${phoneNumber} - ${comment} /* TODO: translate */`,

  HOTLIST_MODAL_DIRECT_LINE: 'Direct Line /* TODO: translate */',

  HOTLIST_MODAL_ENTER_PHONE_NUMBER: 'Enter phone number /* TODO: translate */',

  HOTLIST_MODAL_PHONE_EXTENSION: 'Ext. /* TODO: translate */',

  HOTLIST_MODAL_PHONE_NUMBER_REQUIRED: 'The reporter contact phone number format has an extension but the phone number is missing /* TODO: translate */',

  HOTLIST_MODAL_INVALID_PHONE_NUMBER_FORMAT: 'The reporter contact number format is invalid /* TODO: translate */',

  HOTLIST_MODAL_COMMENT_GUIDANCE: 'Include detailed incident description and next steps for guest follow up... /* TODO: translate */',

  HOTLIST_MODAL_FAILED_TO_LOAD_RESORTS: 'load resortsに失敗しました。',

  HOTLIST_MODAL_RESORT_PLACEHOLDER: 'リゾート...',

  HOTLIST_MODAL_FROM_LABEL: 'From /* TODO: translate */',

  HOTLIST_MODAL_STARTING_DATE_PLACEHOLDER: 'Starting Date... /* TODO: translate */',

  HOTLIST_MODAL_STARTING_DATE_TOOLTIP: 'Enter the starting date for hotlisted status /* TODO: translate */',

  HOTLIST_MODAL_TO_LABEL: 'To /* TODO: translate */',

  HOTLIST_MODAL_ENDING_DATE_PLACEHOLDER: 'Ending Date... /* TODO: translate */',

  HOTLIST_MODAL_ENDING_DATE_TOOLTIP: 'Enter the ending date for hotlisted status /* TODO: translate */',

  HOTLIST_MODAL_REASON: 'Reason for Hotlist /* TODO: translate */',

  HOTLIST_MODAL_REASON_PLACEHOLDER: 'Reason... /* TODO: translate */',

  HOTLIST_MODAL_REASON_FAILED: 'load reasonsに失敗しました。',

  HOTLIST_MODAL_HOTLIST_LABEL: 'Hotlist: /* TODO: translate */',

  HOTLIST_MODAL_COMMENTS_LABEL: 'Comments /* TODO: translate */',

  HOTLIST_MODAL_CANCEL: 'キャンセル',

  HOTLIST_MODAL_CHARACTER_INFO: (minChars: number, maxChars: number) => `(${minChars} to ${maxChars} characters) /* TODO: translate */`,

  HOTLIST_TABLE_HOTLIST: 'Hotlist /* TODO: translate */',

  HOTLIST_TABLE_DURATION: 'Duration /* TODO: translate */',

  HOTLIST_TABLE_COMMENT: 'Comment /* TODO: translate */',

  HOTLIST_TABLE_REMOVE: '削除 From Hotlist',

  HOTLIST_TABLE_UNTIL_EXPIRATION: (date: string) => `Until ${date} /* TODO: translate */`,

  HOTLIST_TABLE_INDEFINITE: 'Indefinite /* TODO: translate */',

  HOTLIST_TABLE_GUEST_LABEL: 'Guest: /* TODO: translate */',

  HOTLIST_TABLE_NO_HOTLIST: 'There are no active hotlists for this guest /* TODO: translate */',

  HOTLIST_REMOVE_MODAL_HEADING: '削除 from Hotlist',

  HOTLIST_REMOVE_MODAL_SUBMIT_TITLE: (guestName: string) => `Take ${guestName} off hotlist /* TODO: translate */`,

  HOTLIST_REMOVE_MODAL_CANCEL_BUTTON: 'キャンセル removing from Hotlist',

  FEATURE_DISABLING_LOADING_GUEST: '読み込み中 guest...',

  FEATURE_DISABLING_NO_PASS: `Guest doesn't have a pass for this season. /* TODO: translate */`,

  FEATURE_DISABLING_DEFERRED: 'Guest is using a deferred pass and cannot redeem entitlements at this time.',

  FEATURE_DISABLING_HOTLISTED:  /* TODO: translate */'Guest is hotlisted and cannot redeem entitlements at this time.',

  FEATURE_DISABLING_WAIVER:  /* TODO: translate */'Guest must sign a waiver first',

  FEATURE_DISABLING_NO_FNF:  /* TODO: translate */'Guest has no friends and family vouchers for this resort.',

  FEATURE_DISABLING_NOT_AVAILABLE:  /* TODO: translate */'This feature is not available at your resort',

  FEATURE_DISABLING_GUEST_IMPORTED:  /* TODO: translate */'Guest is already imported.',

  GUEST_SNACKBAR_FAILED_PHOTO_LOAD: (guestName: string) => `load photo for ${guestName}. Please try againに失敗しました。`,

  GUEST_SNACKBAR_FAILED_PHOTO_SET: (guestName: string) => `set photo for ${guestName}. Please try againに失敗しました。`,

  GUEST_SNACKBAR_FAILED_HOTLIST: (guestName: string) => `load hotlist details for ${guestName}. Please try againに失敗しました。`,

  GUEST_SNACKBAR_FAILED_PASSES: (guestName: string) => `load passes for ${guestName}. Please try againに失敗しました。`,

  GUEST_SNACKBAR_FAILED_LINK: (guestName: string) => `link pass for ${guestName}. Please try againに失敗しました。`,

  GUEST_SNACKBAR_FAILED_SUBMIT_WAIVER: (guestName: string) => `submit waiver for ${guestName}. Please try againに失敗しました。`,

  GUEST_SNACKBAR_FAILED_SUBMIT_REFERENCE: (guestName: string) => `submit local reference for ${guestName}に失敗しました。`,

  GUEST_SNACKBAR_FAILED_IMPORT: (guestName: string, msg: string) => `import ${guestName}.
${msg}に失敗しました。`,

  GUEST_SNACKBAR_SUCCESSFUL_IMPORT: (firstName: string, lastName: string) => `${firstName} ${lastName} が正常にインポートされました。`,

  GUEST_SNACKBAR_SUCCESSFUL_IMPORT_WITH_ENTITLEMENT_ERROR: (firstName: string, lastName: string, entitlementErrorCount: number) => `${firstName} ${lastName} が正常にインポートされました。.
${entitlementErrorCount} entitlement(s) were not imported.`,

// Group Search
  GROUP_MENU_GROUP: (NumberInGroup) => `Group (${NumberInGroup}) /* TODO: translate */`,

  GROUP_MENU_CLOSE_ACTIONS : 'Close Group Actions Menu',

  GROUP_MENU_EXPAND_GROUP:  /* TODO: translate */'Expand the group to take a group action',

  GROUP_MENU_OPEN_GROUP_ACTIONS:  /* TODO: translate */'Open Group Actions Menu',

  GROUP_MENU_NO_GUESTS_CAN_BE_PRINTED:  /* TODO: translate */'No guests can be printed at this time',

  GROUP_MENU_PRINT_PASSES:  /* TODO: translate */'Print passes for the household',

  GROUP_MENU_NO_GUESTS_ELIGIBLE_FOR_IMPORT:  /* TODO: translate */'No guests are eligible for import',

  GROUP_MENU_IMPORT_ALL_HOUSEHOLD:  /* TODO: translate */'Import all eligible household members',

  GROUP_MENU_IMPORTING_GROUP:  /* TODO: translate */'Importing group...',

  GROUP_MENU_PRINT_GROUP:   /* TODO: translate */'Print Group',

  GROUP_MENU_IMPORT_GROUP:  /* TODO: translate */'Import Group',

  HORIZONTAL_GUEST_DETAIL_FIRST_NAME:  /* TODO: translate */'名 Name',

  HORIZONTAL_GUEST_DETAIL_NO_FIRST_NAME:  /* TODO: translate */'いいえ 名 Name',

  HORIZONTAL_GUEST_DETAIL_LAST_NAME:  /* TODO: translate */'姓 Name',

  HORIZONTAL_GUEST_DETAIL_NO_LAST_NAME:  /* TODO: translate */'No Last Name',

  HORIZONTAL_GUEST_DETAIL_YEARS_OLD: (Age) => `${Age} years old /* TODO: translate */`,

  HORIZONTAL_GUEST_DETAIL_NO_BIRTH_DATE: 'いいえ Birth Date',

  HORIZONTAL_GUEST_DETAIL_PRIMARY_EMAIL:  /* TODO: translate */'Primary Email',

  HORIZONTAL_GUEST_DETAIL_NO_EMAIL:  /* TODO: translate */'No Email Address',

  HORIZONTAL_GUEST_DETAIL_PHONE_NUMBER:  /* TODO: translate */'Primary Phone Number',

  HORIZONTAL_GUEST_DETAIL_NO_PHONE_NUMBER:  /* TODO: translate */'No Phone Number',

  GUEST_SEARCH_RESULT_UNEXPECTED_ERROR:  /* TODO: translate */'An unexpected error occurred while loading household. Please try again later.',

  GUEST_SEARCH_RESULT_HIDE_GUESTS:  /* TODO: translate */'Hide Guests',

  GUEST_SEARCH_RESULT_VIEW_GUESTS:  /* TODO: translate */'View Guests',

  GUEST_SEARCH_RESULTS_NO_ACCOUNTS_MATCH:  /* TODO: translate */'No accounts match ',

  GUEST_SEARCH_RESULTS_PLEASE_SEARCH_AGAIN:  /* TODO: translate */', please search again.',

  GUEST_SEARCH_BOX_BLACKLISTED:  /* TODO: translate */'警告：Blacklisted 検索 Term',

  GUEST_SEARCH_MIN_LENGTH: (MinSearchLength) => `警告：${MinSearchLength} Character 検索 Minimum`,

  GUEST_SEARCH_IKON_GUEST: 'Search for an IKON guest',

  GUEST_SEARCH_SEARCH:  /* TODO: translate */'検索',

  GUEST_SEARCH_PLACEHOLDER:  /* TODO: translate */'Find a Guest',

  GUEST_SEARCH_TOP_ACCOUNT_MATCH:  /* TODO: translate */'Top account matching ',

  GUEST_SEARCH_TOP_ACCOUNTS_MATCH: (NumberAccounts) => `Top ${NumberAccounts} accounts matching  /* TODO: translate */`,

  GUEST_SEARCH_SORT_BY: 'Sort By: ',

  GUEST_SORT_MENU_CLOSE:  /* TODO: translate */'Close Sort Menu',

  GUEST_SORT_MENU_OPEN:  /* TODO: translate */'Open Sort Menu',

  GUEST_SORT_RELEVANCE:  /* TODO: translate */'Relevance',

  GUEST_SORT_LAST_NAME_A_Z:  /* TODO: translate */'Last Name (A - Z)',

  GUEST_SORT_LAST_NAME_Z_A:  /* TODO: translate */'Last Name (Z - A)',

  GUEST_SORT_AGE_0_100:  /* TODO: translate */'Age (0 - 100)',

  GUEST_SORT_AGE_100_0:  /* TODO: translate */'Age (100 - 0)',

// PassResortSelector
  PASS_RESORT_SELECTOR_NO_PASSES:  /* TODO: translate */'No passes',

  PASS_RESORT_SELECTOR_PASSES:  /* TODO: translate */'Passes',

  PASS_RESORT_SELECTOR_NO_RESORTS:  /* TODO: translate */'No Resorts',

  PASS_RESORT_SELECTOR_RESORTS:  /* TODO: translate */'Resorts /* TODO: translate */',


  //RTP Script Version
  RTP_SCRIPT_VERSION:  /* TODO: translate */'Script Versions:',

  GET_SCRIPT_VERSION_ACTION_ERROR:  /* TODO: translate */'Something went wrong fetching rtp script versions',

  //検索 History
  GET_SEARCH_HISTORY_ACTION_ERROR: 'Something went wrong fetching user search history',

  CLEAR_SEARCH_HISTORY_ACTION_ERROR:  /* TODO: translate */'Something went wrong clearing user search history',

  SEARCH_HISTORY_RESULTS:  /* TODO: translate */'Search Results:',

  SEARCH_HISTORY_TITLE:  /* TODO: translate */'Search History:',

  SEARCH_HISTORY_CLEAR:   /* TODO: translate */'Clear History',

  // Reports Page
  REPORTS_TITLE: 'Reports /* TODO */',
  REPORTS_PAGE_INFO: 'Run reports based on Resort Tools activity. /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS: 'Guest Hydration Errors /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_MODAL_HEADER: 'Guest Hydration Errors /* TODO */',
  GET_GUEST_HYDRATION_ERRORS_ACTION_ERROR: 'Something went wrong fetching guest hydration errors /* TODO */',
  GUEST_HYDRATION_ERRORS_RETRIED: 'Retried /* TODO */',
  GUEST_HYDRATION_ERRORS_RETRY: 'Retry /* TODO */',
  GUEST_HYDRATION_ERRORS_TOOLTIP: 'Failed hydrations! Please resolve guest errors to retry. /* TODO */',
  GUEST_HYDRATION_REPORT_COPIED_MASTER_GUEST_ID: 'Master Guest ID copied to clipboard /* TODO */',
  GUEST_HYDRATION_REPORT_COPY_MASTER_GUEST_ID: 'Copy Master Guest ID to clipboard /* TODO */',
  GUEST_HYDRATION_REPORT_MGID: 'Master Guest ID /* TODO */',
  GUEST_HYDRATION_REPORT_HYDRATION_ERROR: 'Hydration Error /* TODO */',
  GUEST_HYDRATION_ERRORS_REPLAY_FAILURE: (masterGuestId: string, resortAbbrev: string) => `Unexpected error occurred retrying the guest hydration for ${masterGuestId} at ${resortAbbrev}. Please try again later. /* TODO */`,
  GUEST_HYDRATION_ERRORS_REPLAY_SUCCESS: 'Messages have been sent to the queue for processing /* TODO */',
  GET_GUEST_HYDRATION_ERRORS_COUNT_ACTION_ERROR: 'Something went wrong fetching guest hydration error count /* TODO */',
  GUEST_HYDRATION_ERRORS_GUESTS_PER_PAGE: 'Guests per page: /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_CLOSE: 'Close /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_CLOSE_TITLE: 'Close Guest Hydration Errors Report /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_NO_ERRORS_TOOLTIP: 'No Guest Hydration Errors found! /* TODO */',
  REPORTS_HOTLIST_REASON: 'Reason for Hotlist /* TODO */',
  REPORTS_HOTLIST_REASON_PLACEHOLDER: 'Reason... /* TODO */',
  REPORTS_HOTLIST_REASON_FAILED: 'Failed to load reasons /* TODO */',
  REPORTS_HOTLIST_FROM_LABEL: 'From /* TODO */',
  REPORTS_HOTLIST_FROM_DATE_TOOLTIP: 'Enter the From date for the hotlist report /* TODO */',
  REPORTS_HOTLIST_TO_LABEL: 'To /* TODO */',
  REPORTS_HOTLIST_TO_DATE_TOOLTIP: 'Enter the To date for the hotlist report /* TODO */',
  REPORTS_HOTLIST_NO_REASON: 'A reason is required for the hotlist report. /* TODO */',
  REPORTS_HOTLIST_INVALID_FROM_DATE: 'A valid From date is required for the hotlist report. /* TODO */',
  REPORTS_HOTLIST_INVALID_TO_DATE: 'A valid To date is required for the hotlist report. /* TODO */',
  REPORTS_HOTLIST_FROM_BEFORE_TO_DATE: 'To date must be on or after From date. /* TODO */',
  REPORTS_HOTLIST_DATE_RANGE_MAX: 'Date range too large. The maximum date range for the hotlist report is 1 year. /* TODO */',
  REPORTS_HOTLIST_ERROR_GENERATING_CSV_FILE: 'Something went wrong generating the csv file. /* TODO */',
  REPORTS_HOTLIST_ERROR_DOWNLOAD_FAILED: 'Failed to download hotlist report. /* TODO */',
  REPORTS_HOTLIST_CREATED_DATE: 'Created Date /* TODO */',
  REPORTS_HOTLIST_NARROW_SEARCH_PARAMS: 'Too much data. Please narrow your search parameters. /* TODO */',
  REPORTS_HOTLIST_ERROR_NO_DATA: 'No hotlist data found for the current search parameters. /* TODO */',
  REPORTS_HOTLIST_REQUEST_CANCELLED: 'Request was canceled. Please try again. /* TODO */',
  REPORTS_HOTLIST_INVALID_PARAMETERS: 'Invalid request parameters. /* TODO */',
  REPORTS_WEEKLY_VISTOR_DATA: 'Weekly Visitor Data /* TODO */',
  REPORTS_CLOSE: 'Close /* TODO */',
  REPORTS_WEEKLY_VISITOR_DATA_CLOSE_TITLE: 'Close Weekly Visitor Data Reports /* TODO */',
  REPORTS_WEEKLY_VISITOR_ERROR_LOADING: 'Failed to load Weekly Visitor Data Reports /* TODO */',
  REPORTS_DOWNLOADING: 'Downloading... /* TODO */',
}

export default en_us;
